import { useLanguage } from './language-context';

// The design's EN / বাং switch (Blog design export `.lsw`): a sliding knob that shows the
// current language, with the other language faint in the track. It is a switch whose
// "on" state is Bangla, and its label says what a press does. Persists through the
// language context; every screen re-renders with the new dictionary. `size="sm"` is the
// phone menu's compact variant.
export function LanguageToggle({ size }: { size?: 'sm' } = {}) {
  const { lang, setLang, t } = useLanguage();
  const isBn = lang === 'bn';
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isBn}
      aria-label={t(isBn ? 'sc.lang_to_en' : 'sc.lang_to_bn')}
      className={size === 'sm' ? 'sc-lsw sc-lsw--sm' : 'sc-lsw'}
      onClick={() => setLang(isBn ? 'en' : 'bn')}
    >
      <span className="sc-lbl sc-l-en" aria-hidden="true">
        {t('lang.en_short')}
      </span>
      <span className="sc-lbl sc-l-bn" aria-hidden="true">
        {t('lang.bn_short')}
      </span>
      <span className="sc-tk" aria-hidden="true">
        <span className="sc-k-en">{t('lang.en_short')}</span>
        <span className="sc-k-bn">{t('lang.bn_short')}</span>
      </span>
    </button>
  );
}
